import http from '../../core/services/http';

const loadCompanies = () => http.get('partnerPortal/companies').then(response => response.data);

export default loadCompanies;
